// @flow

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n'

import ArrayUtils from 'PMT/utils/ArrayUtils'

// -- utils
import { StringUtils } from 'PMT/utils'

// -- entities
import CategoryItem from 'PMT/entities/menu/CategoryItem'
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu'

// -- views
import Item from './Item'
import SearchBox from 'PMT/components/SearchBox'

class ItemTabView extends Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
    onToggleItem: PropTypes.func.isRequired,
  }

  state = {
    itemsQuery: '',

    selectedQuery: '',
  }

  // -- search
  onItemsQueryChange = (itemsQuery) => {
    this.setState({
      itemsQuery,
    })
  }

  onSelectedQueryChange = (selectedQuery) => {
    this.setState({
      selectedQuery,
    })
  }

  renderSearchNoResults() {
    return (
      <p>
        <em>
          {I18n.tr('menu.item_selector.search_no_results')}
        </em>
      </p>
    )
  }

  renderColumn(label, listView, query, onQueryChange) {
    return (
      <div className="col-xs-6">
        <h4>{label}</h4>

        <SearchBox
          search={query}
          onSearchInput={onQueryChange}
        />

        <div
          style={{
            maxHeight: '60vh',
            overflow: 'auto',
          }}
        >
          {listView}
        </div>
      </div>
    )
  }

  renderItemsSelected(items: Array<Item>) {
    let listView = null
    if (_.isEmpty(items) && !_.isEmpty(this.state.selectedQuery)) {
      listView = this.renderSearchNoResults()
    } else if (_.isEmpty(items) && _.isEmpty(this.state.selectedQuery)) {
      listView = (
        <p>
          <em>
            {I18n.tr('menu.item_selector.no_item_selected')}
          </em>
        </p>
      )
    } else {
      const sortedItemsList = _.sortBy(items, ['desc'],
        (item): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(item.name).toLowerCase()
        }
      )
      listView = sortedItemsList.map((item: Item) => {
        return (
          <Item
            key={item.id}
            item={item}
            isMainCategory={this.props.restaurantMenu.rootCategoryId === item.id}
            isSelected
            onClick={() => this.props.onToggleItem(item)}
          />
        )
      })
    }

    return this.renderColumn(
      I18n.tr('menu.item_selector.selected'),
      listView,
      this.state.selectedQuery,
      this.onSelectedQueryChange
    )
  }

  renderItemsUnselected(items:Array<Item>) {
    let listView = null
    if (_.isEmpty(items)) {
      listView = this.renderSearchNoResults()
    } else {
      const sortedItemsList = _.sortBy(items, ['desc'],
        (item): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(item.name).toLowerCase()
        }
      )
      listView = sortedItemsList.map((item:Item) => {
        return (
          <Item
            key={item.id}
            item={item}
            isSelected={false}
            isMainCategory={this.props.restaurantMenu.rootCategoryId === item.id}
            onClick={() => this.props.onToggleItem(item)}
          />
        )
      })
    }

    return this.renderColumn(
      I18n.tr('menu.item_selector.products_on_menu'),
      listView,
      this.state.itemsQuery,
      this.onItemsQueryChange
    )
  }

  renderItems() {
    const unselected = []
    const selected = []

    _.each(this.props.options, (option) => {
      const isSelected = !_.isUndefined(_.find(this.props.values, (item) => {
        return item.id === option.id
      }))

      const query: string = isSelected ? this.state.selectedQuery : this.state.itemsQuery
      if (_.isEmpty(query) || StringUtils.searchStringOn(query, option.name)) {
        isSelected ? selected.push(option) : unselected.push(option)
      }
    })

    return (
      <div className="row add_to_category_view__products">
        {this.renderItemsUnselected(unselected)}
        {this.renderItemsSelected(selected)}
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderItems()}
      </div>
    )
  }
}

export default ItemTabView
